import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation, Output, EventEmitter, Inject, ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { OneDialogConfirmationService, OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { Subject } from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AddOwnTemplateDialogComponent } from '../../add-own-template-dialog/add-own-template-dialog.component';
import { MessageAttachmentTemplateDialogComponent } from '../message-attachment-template-dialog/message-attachment-template-dialog.component';
import { QnSbnService } from '../../../services/qn-sbn-service.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'dl-msg-attachment-template',
  templateUrl: './message-attachment-template.component.html',
  styleUrls: ['./message-attachment-template.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageAttachmentTemplateComponent implements OnInit {
  @Input() public isNewFromTemplate: boolean;
  @Input() public addRowData: Subject<any>;
  @Input() public displayedColumns = []; // for template it will include "select" column header and for new no need "select"
  @Input() public tableData = []; // for new single row and for template dynamic no of row will be pass
  // @Output() public isFeedbackOptionAdded = new EventEmitter<{ isOptAdded: boolean }>();
  @Output() public isMessageRowSelected = new EventEmitter<{ messageSelected: any[] }>();
  public dataSource = new MatTableDataSource<any>(this.tableData);
  public selection = new SelectionModel<any>(true, []);

  public constructor(private readonly dialog: MatDialog, public dialogRef: MatDialogRef<MessageAttachmentTemplateDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private changeDetectorRef: ChangeDetectorRef, private qnsbnservice: QnSbnService, private confirmationDialog?: OneDialogConfirmationService, private readonly oneSnackBar?: OneSnackBarService) { }

  public ngOnInit(): void {
    this.addRowData.subscribe(data => {
      //this.dataSource.data = data.placement === 'before' ? [...data.templateData, ...this.dataSource.data] : [...this.dataSource.data, ...data.templateData];
      this.dataSource.data = data.templateData;
    });
    this.dataSource.data = this.tableData;
  }
  public drop(event: CdkDragDrop<string[]>): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
    this.dataSource.data = JSON.parse(JSON.stringify(this.dataSource.data));
  }

  public deleteMessageFromTemplate(elm: any, index: number): void {
    const deleteDialogRef = this.confirmationDialog.open('Delete message template', 'Are you sure you want to delete this message template from your templates?', 'Yes, delete', 'Cancel');

    deleteDialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.qnsbnservice.deleteMessageTemplate(elm.templateId).subscribe(
          (data: any) => {
            if (data.errorMessage) {
              this.oneSnackBar.open(data.errorMessage.errorMessage, OneSnackBarType.ERROR, '', { duration: 5000 });
            } else {
              this.dataSource.data = this.dataSource.data.filter(item => item.templateId !== elm.templateId);
              this.changeDetectorRef.detectChanges();
              this.oneSnackBar.open('Message template successfully deleted from your templates.', OneSnackBarType.SUCCESS);
            }
          },
          (error: HttpErrorResponse) => {
            // console.log('error:', error);
            this.qnsbnservice.httpErrorHandler(error, 'Could not fetch message templates.');
          }
        );
      }
    });
  }

  public updateSelectRowStatus(): void {
    this.isMessageRowSelected.emit({ messageSelected: this.selection.selected });
  }

  public EditMessageTemplate(i): void {
    const dialogRef = this.dialog.open(AddOwnTemplateDialogComponent, {
      data: { tableData: this.dataSource.data[i], columnData: [], rowIndex: i, allTemplates: this.dataSource.data, messageType: 'Email' },
      disableClose: true,
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe(editEntry => {
      if (editEntry.rowIndex >= 0) {
        this.dataSource.data = editEntry.data;
        this.changeDetectorRef.detectChanges();
      }
      // if (editEntry.rowIndex) {
      //   this.dataSource.data[editEntry.rowIndex].templateDetails.templateSubject = editEntry.data.templateSubject;
      //   this.dataSource.data[editEntry.rowIndex].templateDetails.templateBody = editEntry.data.templateBody;
      //   this.changeDetectorRef.detectChanges();
      // }
    });
  }
}
